import React from 'react';
import { MessageCircle, MapPin, Sparkles } from 'lucide-react';
import { siteData } from '../data/siteData';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20"
    >
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[var(--color-cream)] via-white to-[var(--color-cream)]" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-[var(--color-magenta)]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-80 h-80 bg-[var(--color-cyan)]/10 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[var(--color-yellow)]/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[var(--color-magenta)]/10 rounded-full mb-6">
              <Sparkles className="w-4 h-4 text-[var(--color-magenta)]" />
              <span className="text-sm font-medium text-[var(--color-magenta)]">
                Peluquería & Barbería Social
              </span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[var(--text-primary)] mb-6 leading-tight">
              {siteData.hero.title}
            </h1>
            
            <p className="text-lg sm:text-xl text-[var(--text-secondary)] mb-8 max-w-xl mx-auto lg:mx-0">
              {siteData.hero.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Button
                asChild
                size="lg"
                className="w-full sm:w-auto bg-[var(--color-magenta)] hover:bg-[var(--color-purple)] text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <a
                  href={siteData.hero.cta.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <MessageCircle className="w-5 h-5" />
                  {siteData.hero.cta.text}
                </a>
              </Button>
              
              <Button
                asChild
                variant="outline"
                size="lg"
                className="w-full sm:w-auto border-2 border-[var(--color-dark)] text-[var(--text-primary)] hover:bg-[var(--color-dark)] hover:text-white px-8 py-6 text-lg rounded-xl transition-all duration-300"
              >
                <a
                  href={siteData.locations[0].mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <MapPin className="w-5 h-5" />
                  Cómo llegar
                </a>
              </Button>
            </div>

            {/* Trust badges */}
            <div className="flex items-center justify-center lg:justify-start gap-6 mt-8 pt-8 border-t border-gray-200">
              <div className="text-center">
                <p className="text-2xl font-bold text-[var(--color-magenta)]">{siteData.reputation.rating}</p>
                <p className="text-sm text-[var(--text-muted)]">Calificación</p>
              </div>
              <div className="w-px h-12 bg-gray-200" />
              <div className="text-center">
                <p className="text-2xl font-bold text-[var(--color-cyan)]">{siteData.reputation.totalReviews}+</p>
                <p className="text-sm text-[var(--text-muted)]">Opiniones</p>
              </div>
              <div className="w-px h-12 bg-gray-200" />
              <div className="text-center">
                <p className="text-2xl font-bold text-[var(--color-purple)]">2</p>
                <p className="text-sm text-[var(--text-muted)]">Sucursales</p>
              </div>
            </div>
          </div>

          {/* Logo Image */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[var(--color-magenta)]/20 to-[var(--color-cyan)]/20 rounded-3xl blur-2xl scale-110" />
              <img
                src={siteData.business.logo}
                alt={siteData.business.name}
                className="relative w-72 sm:w-80 lg:w-96 h-auto rounded-3xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[var(--color-dark)]/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-[var(--color-magenta)] rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
